var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": `Perfil da Turma em ${_vm.funcionalidade}`,
      "outlined": "",
      "maxlength": "25",
      "dense": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarPerfisTurmas.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Nível de Ensino",
      "items": _vm.form.lists.niveisDeEnsino,
      "item-value": "id",
      "item-text": "descricao",
      "outlined": "",
      "dense": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarPerfisTurmas.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.nivelDeEnsino,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nivelDeEnsino", $$v);
      },
      expression: "form.filters.nivelDeEnsino"
    }
  })], 1), _c('sca-select-ativo', {
    attrs: {
      "cols": 3,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    on: {
      "enter": _vm.buscarPerfisTurmas
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarPerfisTurmas();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterPerfilTurma();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "show-expand": "",
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "no-data-text": _vm.table.noDataText
    },
    scopedSlots: _vm._u([{
      key: "expanded-item",
      fn: function (_ref) {
        var headers = _ref.headers,
          item = _ref.item;
        return [_c('td', {
          staticClass: "blue-grey lighten-5",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('p', {
          staticClass: "ml-4 my-0 text-wrap mx-70vw"
        }, [_vm._v(" " + _vm._s(item.descricao) + " ")])])];
      }
    }, {
      key: `item.situacao`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.ativo,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sca-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarPerfilTurma(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterPerfilTurma(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarPerfilTurma(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarPerfilTurmaDialog', {
    attrs: {
      "titulo": _vm.titulo,
      "niveisDeEnsino": _vm.form.lists.niveisDeEnsino,
      "componentesCurriculares": _vm.form.lists.componentesCurriculares,
      "funcionalidade": _vm.funcionalidade,
      "visible": _vm.dialogManterPerfilTurma.visible,
      "content": _vm.dialogManterPerfilTurma.content,
      "edit": _vm.dialogManterPerfilTurma.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterPerfilTurma.close();
      },
      "onSave": function ($event) {
        return _vm.buscarPerfisTurmas();
      }
    }
  }), _vm.dialogVisualizarPerfilTurma.visible ? _c('VisualizarPerfilTurmaDialog', {
    attrs: {
      "titulo": _vm.titulo,
      "visible": _vm.dialogVisualizarPerfilTurma.visible,
      "content": _vm.dialogVisualizarPerfilTurma.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarPerfilTurma.close();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }